import { render, staticRenderFns } from "./TransitionScreen.vue?vue&type=template&id=ab2c444a&"
import script from "./TransitionScreen.vue?vue&type=script&lang=js&"
export * from "./TransitionScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\soiko\\Documents\\Projects\\game\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab2c444a')) {
      api.createRecord('ab2c444a', component.options)
    } else {
      api.reload('ab2c444a', component.options)
    }
    module.hot.accept("./TransitionScreen.vue?vue&type=template&id=ab2c444a&", function () {
      api.rerender('ab2c444a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TransitionScreen.vue"
export default component.exports